import { NaverBizItemReq, NaverShopSearchReq } from "./api.type";

export const NaverKeys = {
	all: ['naver'] as const,

	// 매장 정보
	shopInfoAll: () => [...NaverKeys.all, 'shopInfo'] as const,
	shopInfo: (payload: NaverShopSearchReq) => [...NaverKeys.all, 'shopInfo', payload.shopCd, payload.page] as const,

	// 주문 유형
	bizItemAll: () => [...NaverKeys.all, 'bizItem'] as const,
	bizItem: (payload: NaverBizItemReq) => [...NaverKeys.all, 'bizItem', payload.shopCd, payload.businessId] as const,

}